export interface ProtocolIdentity {
  icd10Code: string;
  icpcCode: string;
}

export interface ProtocolCodeField {
  code: string;
  nameUa: string;
  nameEn: string;
}

export interface ProtocolIcd10Field extends ProtocolCodeField {
  path?: string;
  level: number;
}

export interface ProtocolAchiField extends ProtocolCodeField {
  originCode: string;
  originalName: string;
  isCustom: boolean;
}

export interface ProtocolLaboratoryField extends ProtocolCodeField {
  loincCodes: string[];
  snomedCodes: string[];
}

// A protocol's pharmacological treatment references a drug by its INN (international
// nonproprietary name); `code` holds the INN identifier. Trademarks bound to the INN
// are resolved separately via the trademarks endpoint.
export type ProtocolDrugField = ProtocolCodeField;

export interface Protocol {
  id: string;
  name: string;
  enabled: boolean;
  identifiers: ProtocolIdentity[];
  coverage: string[];
  differentialDiagnoses: ProtocolIcd10Field[];
  instrumentalDiagnoses: ProtocolAchiField[];
  laboratoryServices: ProtocolLaboratoryField[];
  relatedSpecialists: ProtocolAchiField[];
  nonPharmacologicalTreatments: ProtocolAchiField[];
  pharmacologicalTreatments: ProtocolDrugField[];
  surgicalEndoscopicTreatments: ProtocolAchiField[];
  generalRecommendations: ProtocolCodeField[];
  rehabilitation: ProtocolAchiField[];
  preventions: string[];
  referenceInformation: string[];
  questionnaires: string[];
  inpatientTreatment: boolean;
  tags: string[];
  codes: string[];
  searchText: string;
  needsReview: boolean;
  reviewReason?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedBy?: string | null;
  updatedAt: string;
  deletedAt?: string | null;
  deletedBy?: string | null;
}

export function createEmptyProtocol(): Protocol {
  return {
    id: '',
    name: '',
    enabled: true,
    identifiers: [],
    coverage: [],
    differentialDiagnoses: [],
    instrumentalDiagnoses: [],
    laboratoryServices: [],
    relatedSpecialists: [],
    nonPharmacologicalTreatments: [],
    pharmacologicalTreatments: [],
    surgicalEndoscopicTreatments: [],
    generalRecommendations: [],
    rehabilitation: [],
    preventions: [],
    referenceInformation: [],
    questionnaires: [],
    inpatientTreatment: false,
    tags: [],
    codes: [],
    searchText: '',
    needsReview: false,
    createdAt: '',
    updatedAt: '',
  };
}
